import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { subscribe } from 'alfa';
import { Button, Dropdown, Icon, Menu, message, Typography, Tabs } from 'antd';
import { withTranslation } from 'react-i18next';
import { Link as RealLink } from 'react-router-dom';

import BatchList from './components/BatchList';
import DebitsList from './components/DebitsList';
import BatchRepo from '../../repository/batch';
import Link from '../../components/link';
import { batchType } from '../../helpers/constants';
import AccountTypeRepo from '../../repository/account-type';
import './index.scss';

const { Title } = Typography;
const { Item: MenuItem } = Menu;
const fetchOptions = { check_completed: true };

const BatchIndex = (props) => {
  const { business, account, t } = props;
  const defaultActiveTab = (window.location.pathname.includes('/debits')) ? 'debits' : 'batches';
  const [batchesLoaded, setBatchesLoaded] = useState(true);
  const [debitsLoaded, setDebitsLoaded] = useState(true);
  const [batches, setBatches] = useState([]);
  const [debits, setDebits] = useState([]);
  const [tabKey, setTabKey] = useState(defaultActiveTab);
  const actions = AccountTypeRepo.batchActions(account);

  useEffect(() => {
    const loadBatches = async () => {
      try {
        const { data: { batches: fetchedBatches } } = await BatchRepo.fetchCollection(business, account, fetchOptions);
        setBatches(fetchedBatches);
      } catch (error) {
        console.error('ERROR: BatchRepo.fetchCollection(): ', error); // eslint-disable-line no-console
        message.error(t('error.loading_batches'));
      } finally {
        setBatchesLoaded(false);
      }
    };

    const loadDebits = async () => {
      try {
        const { data: fetchedDebits } = await BatchRepo.fetchDebits(business, account);
        setDebits(fetchedDebits);
      } catch (error) {
        console.error('ERROR: BatchRepo.fetchDebitBatches(): ', error); // eslint-disable-line no-console
        message.error(`${t('error.loading_debits')}: ${error}`);
      } finally {
        setDebitsLoaded(false);
      }
    };

    const loadTab = () => {
      switch (tabKey) {
        case 'debits':
          loadDebits();
          break;
        case 'batches':
          loadBatches();
          break;
        default:
          break;
      }
    };

    loadTab();
  }, [business, account, tabKey, t]);

  const cancelDebit = async () => {
    // eslint-disable-next-line
    const id = prompt('Enter debit ID to cancel:');
    try {
      await BatchRepo.cancelDebit(business, account, id.trim());
      // eslint-disable-next-line
      alert('debit canceled');
    } catch (error) {
      // eslint-disable-next-line
      alert(error);
    }
  };

  const menu = (
    <Menu>
      {actions.map((action) => (
        <MenuItem key={action}>
          <RealLink to={`/accounts/${account.id}/batches/${action}`}>{t(`batch.${batchType[action]}`)}</RealLink>
        </MenuItem>
      ))}
    </Menu>
  );
  const createButton = (actions.length > 1)
    ? (
      <Dropdown overlay={menu}>
        <Button.Group className="float-right">
          <Link button to={`/accounts/${account.id}/batches/${actions[0]}`}><Icon type="plus" /> {t('create_batch')}</Link>
        </Button.Group>
      </Dropdown>
    ) : (
      <Button.Group className="float-right">
        <Link button to={`/accounts/${account.id}/batches/${actions[0] || 'internal'}`}><Icon type="plus" /> {t('create_batch')}</Link>
      </Button.Group>
    );
  const createDebitsButton = (
    <Button.Group className="float-right">
      <Button onClick={cancelDebit}><Icon type="stop" /> {t('cancel_debit')}</Button>
      <Link button to={`/accounts/${account.id}/batches/new-debits`}><Icon type="plus" /> {t('create_batch')}</Link>
    </Button.Group>
  );

  return (
    <>
      <Tabs type="card" onChange={setTabKey} defaultActiveKey={defaultActiveTab}>
        <Tabs.TabPane tab={t('batches')} key="batches">
          <Title level={3}>
            {t('batches')}
            {createButton}
          </Title>
          <BatchList loading={batchesLoaded} batches={batches} />
        </Tabs.TabPane>
        { (business.direct_debit) ? (
          <Tabs.TabPane tab={t('debits')} key="debits">
            <Title level={3}>
              {t('debits')}
              {createDebitsButton}
            </Title>
            <DebitsList loading={debitsLoaded} debits={debits} business={business} account={account} />
          </Tabs.TabPane>
        ) : '' }
      </Tabs>
    </>
  );
};

BatchIndex.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.any,
    product_id: PropTypes.string,
  }),
  business: PropTypes.object,
  t: PropTypes.func,
};

export default subscribe(withTranslation()(BatchIndex), ['business', 'account']);
